import type {
  AnimalTypeEnum,
  ProWorkerGetAvailabilitiesQuery,
  ProfessionalTypeEnum,
} from '@gql/graphql';
import type { ModalData, SelectOption } from '@presentation/components';
import type { Dayjs } from 'dayjs';

export interface BookingSlotPickerFormValues {
  forMultiAnimals: boolean;
  serviceId?: string;
  workerId?: number | 'any';
  bookingStart?: string;
  animalType?: AnimalTypeEnum;
  breedId?: number;
}

export interface BookingFormData {
  services: SelectOption[];
  workers: SelectOption[];
}

// Very very bad passdown of props, refactor this
export interface BookingSlotPickerData {
  disabled?: boolean;
  updateMode?: boolean;
  warning?: string;

  customFormTitle?: string;
  daysWithAvails: {
    date: Dayjs;
    avails: NonNullable<
      ProWorkerGetAvailabilitiesQuery['findBookingAvailabilities']
    >['mergedWorkerAvailabilities'];
  }[];
  nextAvailability?: NonNullable<
    ProWorkerGetAvailabilitiesQuery['findBookingAvailabilities']
  >['nextAvailability'];
  availabilitiesLoading: boolean;
  daysDisplayedCount: number;
  browseBookingDates: (direction: 'nextAvailability' | 'future' | 'past') => void;
  onAvailSelect?: (bookingStart: Dayjs) => void;
  fromDate: Dayjs;

  // NEW
  proType?: ProfessionalTypeEnum;

  animalOptions: SelectOption<AnimalTypeEnum>[];
  breedOptions: SelectOption<number>[];
  // Depenting on form values
  shownFields: Array<keyof BookingSlotPickerFormValues>;
  workerOptions: SelectOption<number | 'any'>[];
  serviceOptions: SelectOption<string>[];

  loading?: boolean;
}

export interface BookingSlotPickerProps extends BookingSlotPickerData {}

export interface PreBookingWarningData {
  proWarning?: string;
  workerServiceWarning?: string;
}

export interface PreBookingWarningProps extends PreBookingWarningData {}

export interface PreBookingWarningModalData {
  modal: ModalData;
  warning: PreBookingWarningData;
}

export interface PreBookingWarningModalProps extends PreBookingWarningModalData {
  onClick: () => void;
}
